// ==============================|| OVERRIDES - LINEAR PROGRESS ||============================== //

export default function LinearProgress() {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: { height: 4, borderRadius: 100 },
        bar: { borderRadius: 100 }
      }
    }
  };
}
